import { render } from "./FormWondeds.vue?vue&type=template&id=0c287af8"
import script from "./FormWondeds.vue?vue&type=script&lang=js"
export * from "./FormWondeds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__